import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

const MODIFY_PLANOGRAM_ITEMS = gql`
	mutation bulkModifyPlanogramItems(
		$input: BulkModifyPlanogramItemsType
	) {
		bulkModifyPlanogramItems(
			input: $input
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

export default MODIFY_PLANOGRAM_ITEMS;

